'use es6';

import { Map as ImmutableMap } from 'immutable';
import { getLanguageNameFromKey } from 'ContentEditorUI/utils/multiLangUtils';
export const findBlog = (blogs, blogIdToFind) => {
  if (!blogs) {
    return null;
  }
  const currentBlog = blogs.find(blog => blog.get('id') === blogIdToFind);
  return currentBlog || null;
};
export const getBlogSlug = (blogs, selectedBlogId) => {
  const selectedBlog = findBlog(blogs, selectedBlogId);
  if (selectedBlog) {
    return selectedBlog.get('slug');
  }
  return '';
};
const slugHasBlogSlug = (blogSlug, slug) => {
  if (blogSlug && blogSlug !== '/') {
    return slug.indexOf(`${blogSlug}/`) === 0;
  }
  return false;
};
export const getSlugWithBlogSlug = (slug, blogs, selectedBlogId) => {
  const blogSlug = getBlogSlug(blogs, selectedBlogId);
  if (slugHasBlogSlug(blogSlug, slug)) {
    return slug;
  }
  return `${blogSlug ? `${blogSlug}/` : ''}${slug}`;
};
export const getBlogUrlWithoutBlogSlug = blog => {
  if (!blog) {
    return '';
  }
  return blog.get('rootUrl').replace(new RegExp(`${blog.get('slug')}$`), '');
};
const makeLanguageSlugRegex = languageSlug => new RegExp(`^${languageSlug}/`);
export const getBlogSlugWithoutLanguage = (blogSlug, blogLanguage) => blogSlug.replace(makeLanguageSlugRegex(blogLanguage), '');
export const slugHasLanguageSlug = (blogSlug, blogLanguage) => makeLanguageSlugRegex(blogLanguage).test(blogSlug);
export const findSuccessfulSocialAutoPublishDate = broadcasts => {
  const successfulAutoPublishBroadcast = broadcasts.find(broadcast => {
    return broadcast.get('clientTag') === 'blog-autopublish-v2' && broadcast.get('status') === 'SUCCESS' && broadcast.get('finishedAt');
  });
  if (successfulAutoPublishBroadcast) {
    return successfulAutoPublishBroadcast.get('finishedAt');
  }
  return null;
};
export const getAllBlogsInLanguageGroupAsMap = currentBlog => {
  const currentBlogLanguage = currentBlog.get('language');
  if (!currentBlogLanguage) {
    return ImmutableMap();
  }
  return currentBlog.get('translations').reduce((blogLanguagesMap, blogVariation, language) => {
    return blogLanguagesMap.set(language, blogVariation.get('id'));
  }, ImmutableMap({
    [currentBlogLanguage]: currentBlog.get('id')
  }));
};
const getBlogLanguageNames = (language, translations) => {
  const languagesStr = translations.reduce((resultStr, variation) => {
    const variationLanguage = variation.get('language');
    if (!variationLanguage) return resultStr;
    return `${resultStr}, ${getLanguageNameFromKey(variationLanguage)}`;
  }, getLanguageNameFromKey(language));
  return `(${languagesStr})`;
};
export const getDisplayBlogName = blog => `${blog.get('name')}${blog.get('language') ? ` ${getBlogLanguageNames(blog.get('language'), blog.get('translations'))}` : ''}`;

// Determines if post with current language can be moved to target blog without warning
export const getCanSafelyMoveBlogs = (postLanguage, blogs, targetBlogId) => {
  const targetBlog = findBlog(blogs, targetBlogId);
  if (!postLanguage) {
    return !targetBlog.get('language');
  }
  const targetBlogLanguagesMap = getAllBlogsInLanguageGroupAsMap(targetBlog);
  return targetBlogLanguagesMap.has(postLanguage);
};
export const getLanguagesForBlogAsSelectOptions = blog => {
  return getAllBlogsInLanguageGroupAsMap(blog).reduce((options, _, language) => {
    options.push({
      text: getLanguageNameFromKey(language),
      value: language
    });
    return options;
  }, []);
};

// Returns the blog from group that has a language that matches the targetLanguage
export const getBlogFromGroupForTargetLanguage = (targetLanguage, blogGroup) => {
  if (!targetLanguage) return blogGroup;
  if (blogGroup.get('language') === targetLanguage) {
    return blogGroup;
  }
  const matchingVariation = blogGroup.get('translations').find(translation => translation.get('language') === targetLanguage);
  return matchingVariation || blogGroup;
};